export class FiltroQuestionarioCargo {
	idConcurso?: number;
	codigoOrgao?: number;
	codigoCargo?: number;
	nomeCargo?: string;
	situacao?: string;
	dataInicioLiberacao?: string;
	dataFimLiberacao?: string;
	page = 1;
	size = 20;
	first = 0;

	calcularFirst() {
		this.first = (this.page - 1) * this.size;
	}

	calcularPage(first: number, size: number) {
		this.page = first / size + 1;
	}
}
